import { render, staticRenderFns } from "./Minderoo.vue?vue&type=template&id=56ff3cb7&scoped=true"
import script from "./Minderoo.vue?vue&type=script&lang=js"
export * from "./Minderoo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ff3cb7",
  null
  
)

export default component.exports